import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "16px",
};

const center = {
  lat: 44.1968404,
  lng: 28.6500037,
};

export default function GoogleMapAware() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCNT-79WzRME3dy8wHIAiQwJ5Jmc2Y1JDM",
  });

  if (!isLoaded) return <div>Se încarcă harta...</div>;

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17}>
      <Marker position={center} />
    </GoogleMap>
  );
}
